import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Single-page apps change "pages" without a reload, so screen-reader users get
// no cue. After a route change this announces the new page title and moves
// focus to <main>, as a normal page load would. In-page #hash jumps are left
// alone (only the pathname is watched).
function RouteAnnouncer() {
    const { pathname } = useLocation();
    const first = useRef(true);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (first.current) {
            first.current = false;
            return undefined;
        }
        // Wait a beat so the new page has rendered and its <title> has updated.
        const timer = setTimeout(() => {
            setMessage(`Navigated to ${document.title}`);
            const main = document.getElementById('main');
            if (main) {
                main.setAttribute('tabindex', '-1');
                main.focus({ preventScroll: true });
            }
        }, 150);
        return () => clearTimeout(timer);
    }, [pathname]);

    return (
        <div role='status' aria-live='polite' className='sr-only'>
            {message}
        </div>
    );
}

export default RouteAnnouncer;
